// removed by extract-text-webpack-plugin
module.exports = {"button":"button_2JxF5","errorMessage":"errorMessage_2IMoX","loader":"loader_2uKT0"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PageIdentificationCgn/style.css
// module id = 190
// module chunks = 0